import {
    SALES_MANAGER_SALES_ROUTES_WIDGET_LOADING,
    SALES_MANAGER_SALES_ROUTES_WIDGET_DATA,
} from '../../../actions/dashboard/widgets/weeklyTaskCompletionBySalesManagers';

const INITIAL_STATE = {
    salesRouteTaskCompletionForSalesManagers: [],
    loading: false,
};

const weeklyTaskCompletionForSalesManagers = (
    state = INITIAL_STATE,
    action,
) => {
    switch (action.type) {
        case SALES_MANAGER_SALES_ROUTES_WIDGET_LOADING:
            return { ...state, loading: true };
        case SALES_MANAGER_SALES_ROUTES_WIDGET_DATA:
            return {
                ...state,
                salesRouteTaskCompletionForSalesManagers: action.data,
                loading: false,
            };
        default:
            return state;
    }
};
export default weeklyTaskCompletionForSalesManagers;
